import * as React from 'react';
import './style.css';
import * as ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
let timer = null;

function init() {
    clearTimeout(timer);
    let dark_toast = document.getElementById('grt-dark-toast-mask');
    if (dark_toast) {
        dark_toast.style.display = 'flex';
    } else {
        let div = document.createElement('div');
        div.setAttribute('id', 'grt-dark-toast-mask');
        document.body.appendChild(div);
    }
}
function setTime(timeout) {
    timer = setTimeout(() => {
        let dark_toast_mask = document.getElementById('grt-dark-toast-mask');
        if (dark_toast_mask) {
            dark_toast_mask.style.display = 'none';
        }
    }, timeout);
}
function renderDom(msg, timeout) {
    init();
    setTime(timeout);
    const ele = (
        <ConfigProvider prefixCls="main">
            <div id="dark-toast">{msg}</div>
        </ConfigProvider>
    );
    // ReactDOM.render(ele, document.getElementById('grt-dark-toast-mask'));
    ReactDOM.createRoot(document.getElementById('grt-dark-toast-mask')).render(ele);
}
class Toast extends React.Component {
    static info(msg, timeout = 2000) {
        renderDom(msg, timeout);
    }
    static success(msg, timeout = 2000) {
        renderDom(msg, timeout);
    }
    static warning(msg, timeout = 2000) {
        renderDom(msg, timeout);
    }
    static error(msg, timeout = 2000) {
        renderDom(msg, timeout);
    }
}

export default Toast;
